/* generated using openapi-typescript-codegen -- do not edit */
/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */
import type { BindLineTokenRequest } from '../models/BindLineTokenRequest';
import type { CreateTokenRequest } from '../models/CreateTokenRequest';
import type { EnableTokenRequest } from '../models/EnableTokenRequest';
import type { LineShopLinkToken } from '../models/LineShopLinkToken';
import type { LineShopLinkTokenDto } from '../models/LineShopLinkTokenDto';
import type { PaginatedLineShopLinkTokenDto } from '../models/PaginatedLineShopLinkTokenDto';
import type { CancelablePromise } from '../core/CancelablePromise';
import type { BaseHttpRequest } from '../core/BaseHttpRequest';
export class LineShopLinkTokenService {
    constructor(public readonly httpRequest: BaseHttpRequest) {}
    /**
     * @returns any OK
     * @throws ApiError
     */
    public updateTokenEnabled({
        tokenId,
        requestBody,
    }: {
        tokenId: string,
        requestBody: EnableTokenRequest,
    }): CancelablePromise<any> {
        return this.httpRequest.request({
            method: 'PUT',
            url: '/v2/line-link/tokens/{tokenId}/enabled',
            path: {
                'tokenId': tokenId,
            },
            body: requestBody,
            mediaType: 'application/json',
            errors: {
                400: `Bad Request`,
            },
        });
    }
    /**
     * ยกเลิกการผูก LINE กับร้านค้า
     * @returns any OK
     * @throws ApiError
     */
    public cancelLinkToken({
        tokenId,
    }: {
        tokenId: string,
    }): CancelablePromise<any> {
        return this.httpRequest.request({
            method: 'PUT',
            url: '/v2/line-link/tokens/{tokenId}/cancel',
            path: {
                'tokenId': tokenId,
            },
            errors: {
                400: `Bad Request`,
            },
        });
    }
    /**
     * @returns LineShopLinkToken OK
     * @throws ApiError
     */
    public createToken({
        requestBody,
    }: {
        requestBody: CreateTokenRequest,
    }): CancelablePromise<LineShopLinkToken> {
        return this.httpRequest.request({
            method: 'POST',
            url: '/v2/line-link/tokens',
            body: requestBody,
            mediaType: 'application/json',
            errors: {
                400: `Bad Request`,
            },
        });
    }
    /**
     * @returns LineShopLinkTokenDto OK
     * @throws ApiError
     */
    public getByShopPost({
        requestBody,
    }: {
        requestBody: CreateTokenRequest,
    }): CancelablePromise<Array<LineShopLinkTokenDto>> {
        return this.httpRequest.request({
            method: 'POST',
            url: '/v2/line-link/tokens/search',
            body: requestBody,
            mediaType: 'application/json',
            errors: {
                400: `Bad Request`,
            },
        });
    }
    /**
     * ใช้ในฝั่ง LINE Bot ไม่ต้อง login
     * @returns LineShopLinkToken OK
     * @throws ApiError
     */
    public bindToken({
        requestBody,
    }: {
        requestBody: BindLineTokenRequest,
    }): CancelablePromise<LineShopLinkToken> {
        return this.httpRequest.request({
            method: 'POST',
            url: '/v2/line-link/bind',
            body: requestBody,
            mediaType: 'application/json',
            errors: {
                400: `Bad Request`,
            },
        });
    }
    /**
     * @returns PaginatedLineShopLinkTokenDto OK
     * @throws ApiError
     */
    public searchLineTokens({
        shopId,
        search = '',
        sortBy = '',
        direction = 'desc',
        page,
        limit = 20,
    }: {
        shopId: string,
        search?: string,
        sortBy?: string,
        direction?: string,
        page?: number,
        limit?: number,
    }): CancelablePromise<PaginatedLineShopLinkTokenDto> {
        return this.httpRequest.request({
            method: 'GET',
            url: '/v2/line-link/{shopId}/tokens/search',
            path: {
                'shopId': shopId,
            },
            query: {
                'search': search,
                'sortBy': sortBy,
                'direction': direction,
                'page': page,
                'limit': limit,
            },
            errors: {
                400: `Bad Request`,
            },
        });
    }
    /**
     * @returns string OK
     * @throws ApiError
     */
    public getShopIdFromRoomId({
        roomId,
    }: {
        roomId: string,
    }): CancelablePromise<string> {
        return this.httpRequest.request({
            method: 'GET',
            url: '/v2/line-link/user/{roomId}',
            path: {
                'roomId': roomId,
            },
            errors: {
                400: `Bad Request`,
            },
        });
    }
    /**
     * @returns string OK
     * @throws ApiError
     */
    public getShopIdFromLineUser({
        lineUserId,
    }: {
        lineUserId: string,
    }): CancelablePromise<string> {
        return this.httpRequest.request({
            method: 'GET',
            url: '/v2/line-link/user/{lineUserId}',
            path: {
                'lineUserId': lineUserId,
            },
            errors: {
                400: `Bad Request`,
            },
        });
    }
    /**
     * @returns any OK
     * @throws ApiError
     */
    public deleteToken({
        token,
    }: {
        token: string,
    }): CancelablePromise<any> {
        return this.httpRequest.request({
            method: 'DELETE',
            url: '/v2/line-link/tokens/{token}',
            path: {
                'token': token,
            },
            errors: {
                400: `Bad Request`,
            },
        });
    }
}
